import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {DomSanitizer} from '@angular/platform-browser';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {environment} from '../../../environments/environment';
import {UserLogged} from '../../models/userLogged';

@Component({
  selector: 'app-authentication-setup',
  templateUrl: './authenticator-setup.component.html',
  styleUrls: ['./authenticator-setup.component.scss']
})
export class AuthenticatorSetupComponent implements OnInit {

  public currentUser: UserLogged;
  invalidAuthCode = false;
  isCard1 = true;
  isCard2 = false;
  isCard3 = false;
  googleAdd: string;

  constructor(private authService: AuthenticationService,
              private utilsService: UtilsService,
              private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.currentUser = this.authService.getUserCurrent();
    this.googleAdd = '../../../assets/images/google_add.png';
  }

  getQrCodeUrl() {
    return this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64, ' + this.currentUser.authenticatorQrCode);
  }

  logout() {
    this.authService.logoutUser();
  }

  verifyCode(code) {
    if (code.length === 6) {
      this.authService.confirmGoogleAuthenticatorCode(code).subscribe({
        next: res => {
          this.setCookieToken(res);
          this.invalidAuthCode = false;
          this.deleteAuthToken();
          this.utilsService.deleteCookie('setup');
          location.reload();
        },
        error: () => {
          this.invalidAuthCode = true;
        }
      });
    }
  }

  showCard2() {
    this.isCard1 = false;
    this.isCard2 = true;
    this.isCard3 = false;
  }

  showCard1() {
    this.isCard1 = true;
    this.isCard2 = false;
    this.isCard3 = false;
  }

  showCard3() {
    this.isCard2 = false;
    this.isCard3 = true;
  }

  private deleteAuthToken() {
    this.utilsService.deleteCookie('token');
    localStorage.removeItem('token');
    localStorage.removeItem('token' + environment.subCookiesDomain);
    window.location.reload();
  }

  private setCookieToken(res) {
    const expireDate = new Date();
    expireDate.setMonth(expireDate.getMonth() + 1);
    const token = res['mfa-token-' + this.authService.getUserCurrent().uniqid + environment.subCookiesDomain];
    if (token) {
      const mfaCookieName = 'mfa-token-' + this.authService.getUserCurrent().uniqid;
      this.utilsService.deleteCookie(mfaCookieName);
      this.utilsService.saveCookie(mfaCookieName, token, expireDate);
    }
  }
}
